import React from 'react'
import styles from './AnimatedIcon.m.sass'
import Lottie from 'lottie-react'

export interface AnimatedIconProps extends React.SVGAttributes<SVGElement> {
  name: AnimatedIconName
  size?: number
}

export default React.forwardRef(
  (props: AnimatedIconProps, ref: React.Ref<any>) => {
    const { name, size } = props
    const animationData = animatedIconsMap.get(name)

    return (
      <Lottie
        ref={ref}
        animationData={animationData}
        loop={true}
        style={
          size === undefined
            ? { width: '24px', height: '24px' }
            : { width: `${size}px`, height: `${size}px` }
        }
        className={styles.animatedIcon}
      />
    )
  },
)

const animatedIconsMap = new Map<string, any>([
  ['stars', require('assets/lotties/stars.json')],
  ['ic-taxfyle-loop', require('assets/lotties/ic-taxfyle-loop.json')],
])

export type AnimatedIconName = 'stars' | 'ic-taxfyle-loop'
